import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { ActionButtonProps } from '../ActionButton'
import { LinkProps } from '../Link'
import { BreadcrumbProps } from '../Breadcrumb'

import * as SC from './styled'

export type AdsIntroProps = {
  className?: string
  title: string
  breadcrumb: BreadcrumbProps
  text: string
  helpText?: string
  map: ImageProps
  adsInformation: {
    viewed: string
    interested: string
    update: string
  }
  address: string
  link: LinkProps
  button?: ActionButtonProps
}

const AdsIntro: FC<AdsIntroProps> = ({
  className,
  title,
  breadcrumb,
  text,
  helpText,
  map,
  adsInformation,
  address,
  link,
  button,
}) => {
  return (
    <SC.AdsIntro className={cx('AdsIntro', className)}>
      <SC.Wrapper>
        <SC.Container>
          <SC.Title>{title}</SC.Title>
          <SC.BreadcrumbElement {...breadcrumb} />
          <SC.Text>{text}</SC.Text>
          {helpText && <SC.HelpText>{helpText}</SC.HelpText>}
        </SC.Container>
        <SC.MapContainer>
          <SC.Map {...map} />
          <SC.AddressWrapper>
            <SC.Address>{address}</SC.Address>
            <SC.ViewItineraryLink {...link} />
          </SC.AddressWrapper>
        </SC.MapContainer>
        <SC.AdsInformation>
          <SC.AdsInformationParagraph suppressHydrationWarning>
            {adsInformation.viewed}
          </SC.AdsInformationParagraph>
          <SC.AdsInformationParagraph suppressHydrationWarning>
            {adsInformation.interested}
          </SC.AdsInformationParagraph>
          <SC.AdsInformationParagraph suppressHydrationWarning>
            {adsInformation.update}
          </SC.AdsInformationParagraph>
        </SC.AdsInformation>
        {button && (
          <SC.ButtonContainer>
            <SC.Button {...button} />
          </SC.ButtonContainer>
        )}
      </SC.Wrapper>
      <SC.Separator />
    </SC.AdsIntro>
  )
}

export default AdsIntro
